import Model from './Model'

/** @abstract */
export default class BaseItem extends Model {

	/** @type string */ display_name
	/** @type string */ menu_name
	/** @type number */ menu_item_id
	/** @type number */ price_value
	/** @type boolean */ is_open_item

	/** Shows in the Menu Item List, but it's also available for ordered items. It's a single category, and if the item is displayed in more than one, it will be repeated throughout the list, with different categories here.
	 * @type ?string */ category

	/**
	 * Uses the React "hack" to turn <br> into an actual line break
	 * @return {JSX.Element}
	 */
	get display_name_with_HTML() {
		return <span dangerouslySetInnerHTML={{ __html: this.display_name }}/>
	}

	/**
	 * Tags surely stripped from {@link display_name}.
	 * @return {string}
	 * @see https://stackoverflow.com/a/47140708/102960
	 */
	get display_name_without_HTML() {
		return new DOMParser().parseFromString(this.display_name, 'text/html').body.textContent || ''
	}

	get has_category() {
		if (this.hasOwnProperty('category_id')) {
			return !!this.category_id
		}
		if (this.hasOwnProperty('category_ids')) {
			return !!this.category_ids.length
		}
		console.warn('Trying to decide if an item has categories but no category field is present!', this)
		return true
	}
}
